import React, { useEffect, useState } from 'react'
import { firestore } from '../../../../../firebase';

function RegisterPlayerRoundFirebase({roundId, id, playersAdded}) {

    const [players, setPlayers] = useState([]);

    const [filteredPlayers, setFilteredPlayers] = useState([])

    const [searchTerm, setSearchTerm] = useState("")

    useEffect(() => {

        try {
            const playersRef = firestore.collection("hostcup").doc(id).collection("players");
            playersRef.onSnapshot(({docs}) => {
                const players = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                });
                setPlayers(players);
            })
        } catch (error) {
            
        }

    }, [id])

    useEffect(() => {

        if (searchTerm && players) {
            console.log(searchTerm, "searchTerm")
            const filteredPlayers = players.filter(player => {
                let playerName = player.name.toLowerCase()
                return playerName.includes(searchTerm)
            })
            setFilteredPlayers(filteredPlayers)
        }

    }, [searchTerm, players])



    async function registerHandler(e, player) {
        e.preventDefault();
        try {
            
            if (playersAdded.includes(player.id)) {
                console.log("Lagt til fra før")
                return
            }

            const playersRoundRef = firestore.collection("hostcup").doc(id).collection("rounds").doc(roundId).collection("players");
            const data = {
                player_name: player.name,
                player_id: player.id
            }
            playersRoundRef.add(data);
        } catch (error) {
            
        }
    }
    function isPlayerAdded(player) {

        let isAddedStatus;

        const isAdded = playersAdded.filter(playerAdded => {
            //console.log(playerAdded, player)
            return playerAdded === player.id
        })
        
        if (isAdded.length > 0) {
            isAddedStatus = true;
        } else {
            isAddedStatus = false
        }
        return isAddedStatus
    }


    return (
        <ul className="list-group">
            <label>Søk spiller</label>
            <input className="form-control" placeholder="Søk spiller" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />

            {searchTerm && searchTerm.length && searchTerm !== ""  && searchTerm !== null && searchTerm !== undefined && 
                <h4 className="font-weight-bold my-3">Søkeresultater:</h4>
            }
            {filteredPlayers?.map((player, index) => {
                return (
                    <li className="list-group-item" key={index}>

                        <div>
                            {player.name} 
                            <span className="float-right">
                                <button 
                                    onClick={(e) => registerHandler(e, player)} 
                                    className={playersAdded && isPlayerAdded(player) ? "btn btn-sm btn-danger" : "btn btn-sm btn-success"}
                                >
                                    <i className={playersAdded && isPlayerAdded(player) ? "fas fa-check" : "fas fa-plus"}></i>
                                </button>
                            </span>
                        </div>

                    </li>
                )
            })}
            {!filteredPlayers.length && searchTerm !== "" && <div className="alert alert-danger">Ingen spillere funnet </div>}

            <h4 className="my-5 text-center font-weight-bold">Alle spillere</h4>
            {players?.map((player, index) => {
                return (
                    <li className="list-group-item" key={index}>

                        <div>
                            {player.name} 
                            <span className="float-right">
                                <button 
                                    onClick={(e) => registerHandler(e, player)} 
                                    className={playersAdded && isPlayerAdded(player) ? "btn btn-sm btn-danger" : "btn btn-sm btn-success"}
                                >
                                    <i className={playersAdded && isPlayerAdded(player) ? "fas fa-check" : "fas fa-plus"}></i>
                                </button>
                            </span>
                        </div>

                    </li>
                )
            })}
        </ul>
    )

}
export default RegisterPlayerRoundFirebase